import React from 'react'
import Footer from './Footer'
import Header from './Header'

const Rate_card_b2c = () => {
    return (
        <div>
            <Header />
            <div class="page-wrapper pinned">
                <div class="main-container">
                    <div className='app-container'>
                        <div class="app-body">
                            <div class="row mb-2">
                                <div class="col-12 col-md">
                                    <div class="d-flex">


                                        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
                                        <h2>Rate Card B2C</h2>

                                    </div>
                                </div>

                            </div>
                            <iframe
                                src="https://skyship.com/prices/price.php?type=b2c"
                                title="Rate Card B2C"
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                            ></iframe>

                            <div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>

            </div>
        </div>
    )
}

export default Rate_card_b2c
